// CacheKey 0553d1e4f5d29c9847c43a2a8913a422
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-UCSF_MEDICAL_CENTER": {
    models: {
      task: "intervention",
      tasks: "interventions",
      Task: "Intervention",
      Tasks: "Interventions"
    },
    exports: {
      defaults: {
        task: {
          id: "Intervention ID",
          name: "Intervention Name"
        }
      }
    },
    agenda: {
      info: "All interventions assigned to you that are overdue or due in the next 6 days.",
      loading: "Loading {{user}} upcoming interventions…"
    },
    closed_tasks: {
      nav: "Closed Interventions",
      title: "Recently Closed Interventions",
      pending_tasks: "Go to My Pending Interventions"
    },
    pending_tasks: {
      title: "My Pending Interventions",
      info: "Upcoming interventions assigned to you.",
      closed_tasks: "Go to Recently Closed Interventions"
    },
    patient_tasks: {
      title: "Upcoming Interventions"
    },
    tasks_search: {
      nav: "All Interventions",
      title: "Interventions Search"
    },
    tasks_export: {
      nav: "Interventions Export",
      title: "Interventions Export"
    }
  }
}

